import { Create } from '../Vod/VodFactoryCreator';
import { VodBaseRenderModel } from '../Vod/VodBaseRenderModel';
import VodModuleTypeEnum from '@/enums/VodModuleTypeEnum';
import { t } from '@/main';
import { VodDetail } from '@/entities/VodDetail';
import VideoScheduleEnums from '@/enums/VideoScheduleEnums';
import VirtualMeetingtypeParentEnum from '@/enums/VirtualMeetingtypeParentEnum';

export class ProgramRenderer implements Create {
  public GetValues(vodDetail: VodDetail, entityId: number, sessionStartDate: Date, uploadUrl: string, acceptedVideoFileTypes: string, acceptedCaptionFileTypes: string, subModuleType: number): VodBaseRenderModel {
    const ProgramRendererBaseClass: VodBaseRenderModel = new VodBaseRenderModel();
    ProgramRendererBaseClass.Moduletype = VodModuleTypeEnum[0].toString();
    ProgramRendererBaseClass.SubModuleType = subModuleType;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
    ProgramRendererBaseClass.SubModuleTypeValue = VirtualMeetingtypeParentEnum[subModuleType].toString(),
    ProgramRendererBaseClass.ShowAddCaption = true;
    ProgramRendererBaseClass.ShowPublish = true;
    const PublishItemList =  [{ Text : t('VirtualMeetings.AddVideo.PublishNow').toString() , Value : 1 },
      { Text : t('VirtualMeetings.AddVideo.FifteenMinutesBefore').toString() , Value : 2 },
      { Text : t('VirtualMeetings.AddVideo.CustomPublish').toString() , Value : 3 }];
    ProgramRendererBaseClass.PublishItemList = PublishItemList;
    ProgramRendererBaseClass.VodDetail = vodDetail;
    ProgramRendererBaseClass.EntityId = entityId;
    ProgramRendererBaseClass.UploadUrl = uploadUrl;
    ProgramRendererBaseClass.AcceptedVideoFileTypes = acceptedVideoFileTypes;
    ProgramRendererBaseClass.AcceptedCaptionFileTypes = acceptedCaptionFileTypes;
    ProgramRendererBaseClass.PercentageVideoUploaded = 0;
    ProgramRendererBaseClass.SessionStartDate = sessionStartDate;
    ProgramRendererBaseClass.DefaultValue = VideoScheduleEnums.FifteenMinPriorToSession;
    ProgramRendererBaseClass.Title = t('Program.ProgramTab').toString();
    return ProgramRendererBaseClass;
  }
}
